import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskOrganizationV2Route: InvariantJiraRoute = {
	name: 'servicedesk-organization_v2',
	path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
	exact: true,
};
